class AyaTargetCarousel extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    const list = this.querySelector('.aya-target-areas__list');
    const dots = this.querySelector('.aya-target-areas__dots');
    if (!list || !dots) return;
    dots.hidden = list.children.length < 2;
    const buttons = [...dots.querySelectorAll('button')];
    const position = index => list.children[index].offsetLeft - list.children[0].offsetLeft;
    buttons.forEach((button, index) => button.addEventListener('click', () => {
      list.scrollTo({ left: position(index), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }, { signal }));
    list.addEventListener('scroll', () => {
      let nearest = 0;
      buttons.forEach((_, index) => {
        if (Math.abs(position(index) - list.scrollLeft) < Math.abs(position(nearest) - list.scrollLeft)) nearest = index;
      });
      buttons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === nearest)));
    }, { signal, passive: true });
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('aya-target-carousel')) customElements.define('aya-target-carousel', AyaTargetCarousel);
